const activeClass = 'is-active'
let brandTriggers = document.querySelectorAll('.js-brand-trigger')

brandTriggers.forEach(function (brandTrigger, index) {
  const dataBrandTarget = brandTrigger.dataset.brandTarget
  const brandTargetedElement = document.querySelector('[data-brand-id="'+ dataBrandTarget +'"]')

  brandTrigger.addEventListener('mouseover', function () {
    brandTargetedElement.classList.add(activeClass)
  })

  brandTrigger.addEventListener('mouseout', function () {
    let brandElements = document.querySelectorAll('.js-brand-element')

    brandElements.forEach(function (brandElement, index) {
      brandElement.classList.remove(activeClass)
    })
  })
})
